import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const RotateLeft = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="RotateLeft" {...props}>
    <path d="M2 0.5C2.55228 0.5 3 0.947715 3 1.5V4.45215C5.00486 2.32802 7.84659 1 11 1C17.0751 1 22 5.92487 22 12C22 18.0751 17.0751 23 11 23C6.84753 23 3.23395 20.699 1.3623 17.3066L1.18652 16.9746L1.14453 16.8809C0.962107 16.4082 1.16445 15.8643 1.62598 15.6299C2.08759 15.3958 2.64509 15.5541 2.91895 15.9805L2.96973 16.0693L3.11426 16.3408C4.64775 19.1203 7.60506 21 11 21C15.9706 21 20 16.9706 20 12C20 7.02944 15.9706 3 11 3C8.10208 3 5.52396 4.37009 3.87695 6.5H8C8.55228 6.5 9 6.94772 9 7.5C9 8.05228 8.55228 8.5 8 8.5H2.12988C1.50589 8.49994 1.00006 7.99411 1 7.37012V1.5C1 0.947715 1.44772 0.5 2 0.5Z" fill="#000" />
  </StyledIcon>
));

RotateLeft.displayName = 'RotateLeft';

export { RotateLeft };
